import DependencyInjector from '../utils/DependencyInjector';
import { CustomEvents } from '../utils/CustomEvents';
import { Matchmq } from '../utils/ResolutionHandler';
import { getFirstFocusable } from '../utils/FocusableElementUtils';
import { on, emit, off, one } from '../utils/EventsBus';
import { doAjax } from '../utils/ajaxUtil';

/**
 * Generic web component that expose a render method
 */
export default class Component {
  constructor(htmlEl) {
    this.moduleLoader = new DependencyInjector(); // Use this class to lazy load modules!!
    this.$component = htmlEl;
    this.$customEvents = CustomEvents;
    this.$matchMedia = Matchmq;
    this.$on = on;
    this.$emit = emit;
    this.$off = off;
    this.$one = one;
    this.$doAjax = doAjax;
    this.$getFirstFocusable = getFirstFocusable;
    this.$importComponent = this.importComponent;
  }

  /**
   * Log utility
   * @param logStr
   */
  log(logStr = '', params = '') {
    if (logStr != '') {
      let myName = this.constructor.name;
      console.log('['+myName+']'+logStr+' ' , params );
    }
  }

  /**
   * Log utility
   * @param logStr
   */
  warn(logStr = '', params = '') {
    if (logStr != '') {
      let myName = this.constructor.name;
      console.warn(`[${myName}] ${logStr} ${params}`);
    }
  }

  importComponent(component) {
    $('body').append(`<div data-js-component="${component}"></div>`);
    return true;
  }

  /*
    Main method that execute the render logic of the component
   */
  render() {
    let myName = this.constructor.name;
    console.log(`[${myName}] Rendering..`);
  }
}
